import JsBarcode from "jsbarcode";
import pdfMake from 'pdfmake/build/pdfmake';
import { TDocumentDefinitions } from "pdfmake/interfaces";

export const convertImageToBase64 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

const generateBarcode = (data: string) => {
    const canvas = document.createElement('canvas'); // Create a canvas element
    JsBarcode(canvas, data, {
        format: 'CODE128',
        displayValue: false,
        width: 30,
        lineColor: 'black',
        background: 'white'
    }); // Generate the barcode
    return canvas.toDataURL(); // Convert the canvas to a data URL
};

export const createAllQrPdf = async (qrData: { alphabet: string, number: number }) => {
    const imageDataUrl = await convertImageToBase64('./pdfLogo.png')
    const qrArray = Array.from({ length: qrData.number }, (_, index) => `${qrData.alphabet}${index + 1}`);
    console.log(qrArray);
    const pdfContent: any[] = await Promise.all(qrArray.map(async (binlocation: string) => {
        return [
            {
                columns: [
                    {
                        image: imageDataUrl,
                        alignment: 'left',
                        margin: [0, -16, 0, 0],
                        fit: [80, 80], // Add this property to specify the image size
                        style: 'redBackground'
                    },
                    {
                        text: `SVP SPORTS`,
                        style: 'body',
                        fontSize: 30,
                        color: 'black',
                        alignment: 'left',
                        margin: [-120, 0, 0, 0],
                    },
                ]
            },
            {
                text: binlocation,
                style: 'body',
                fontSize: binlocation.length > 3 ? 300 : 370,
                color: 'white',
                alignment: 'center',
                margin: binlocation.length > 3 ? [-60, 20, 0, 0] : [0, -20, 0, 0],
            },
            {
                image: generateBarcode(binlocation),
                width: 420,
                height: 60,
                margin: binlocation.length > 3 ? [0, 25, 0, 20] : [0, -20, 0, 20],
                alignment: 'center',
            }
        ];
    }));
    // Flatten the array of arrays into a single array
    const flattenedContent = pdfContent.flat();
    const docDefinition: TDocumentDefinitions = {
        content: flattenedContent,
        pageOrientation: 'landscape',
        background: function (currentPage, pageSize) {
            return {
                canvas: [
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: pageSize.width,
                        h: pageSize.height * 0.76,
                        color: '#006c8c',
                    },
                    {
                        type: 'rect',
                        x: 0,
                        y: 0,
                        w: pageSize.width,
                        h: pageSize.height * 0.2,
                        color: 'white',
                    },
                ],
            };
        },
        styles: {
            header: {
                fontSize: 30,
                alignment: 'center',
                bold: true,
                margin: [0, 50, 0, 20],
                background: 'white',
                fillColor: 'white'
            },
            qrCode: {
                alignment: 'center',
                background: 'white',
                fillColor: 'white'
            },
            body: {
                alignment: 'center',
                fillColor: 'white',
                bold: true
            },
            redBackground: {
                fillColor: 'red',
            },
        },
    };
    pdfMake.createPdf(docDefinition).open();
}

export const createBarcodePdf = async (barcode: string) => {
    const imagePath = './pdfLogo.png';
    const imageDataUrl = await convertImageToBase64(imagePath);
    try {
        const docDefinition: TDocumentDefinitions = {
            background: function (currentPage, pageSize) {
                return {
                    canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: pageSize.height * 0.76,
                            color: '#006c8c',
                        },
                        {
                            type: 'rect',
                            x: 0,
                            y: 0,
                            w: pageSize.width,
                            h: pageSize.height * 0.2,
                            color: 'white',
                        },
                    ],
                };
            },
            content: [
                {
                    columns: [
                        {
                            image: imageDataUrl,
                            alignment: 'left',
                            margin: [0, -16, 0, 0],
                            fit: [80, 80], // Add this property to specify the image size
                            style: 'redBackground'
                        },
                        {
                            text: `SVP SPORTS`,
                            style: 'body',
                            fontSize: 30,
                            color: 'black',
                            alignment: 'left',
                            margin: [-120, 0, 0, 0],
                        },
                    ]
                },
                {
                    text: barcode.toUpperCase(),
                    style: 'body',
                    fontSize: barcode.length > 3 ? 300 : 370,
                    color: 'white',
                    alignment: 'center',
                    margin: barcode.length > 3 ? [-60, 20, 0, 0] : [0, -20, 0, 0],
                },
                {
                    image: generateBarcode(barcode.toUpperCase()),
                    width: 420,
                    height: 60,
                    margin: barcode.length > 3 ? [0, 25, 0, 20] : [0, -20, 0, 20],
                    alignment: 'center',
                }
            ],
            styles: {
                header: {
                    fontSize: 30,
                    alignment: 'center',
                    bold: true,
                    margin: [0, 50, 0, 20],
                    background: 'white',
                    fillColor: 'white'
                },
                qrCode: {
                    alignment: 'center',
                    background: 'white',
                    fillColor: 'white'
                },
                body: {
                    alignment: 'center',
                    fillColor: 'white',
                    bold: true
                },
                redBackground: {
                    fillColor: 'red',
                },
            },
            pageOrientation: 'landscape',
        };
        pdfMake.createPdf(docDefinition).open();
    } catch (error) {
        console.log('Error Creating PDF:', error);
    }
}